import { prop, ComponentEventBus, inject } from "fw";

let uniqueId = 0;

@inject
export class CheckboxField {
    @prop(null) private label;
    @prop(null) private value;
    @prop(null) private valueList;
    @prop(null) private validation;
    @prop(null) private readonly;
    @prop(false) private disabled;

    private uniqueId = uniqueId++;

    constructor(private ceb: ComponentEventBus) {}

    get id() {
        return `${this.label ? this.label.replace(/\s/g, "") : ""}-cb-${this.uniqueId}`;
    }

    get pValue() {
        return this.value;
    }

    set pValue(v) {
        this.ceb.updateModel(v);
    }

    get pValueList() {
        return this.valueList;
    }

    set pValueList(m) {
        this.ceb.dispatch("update:valueList", m);
    }

    get isChecked() {
        if (this.valueList != null) {
            return this.valueList.includes(this.value);
        }

        return this.value;
    }
}
